AFRAME.registerComponent("artwork-pivot", {
  schema: {
    position: { type: "string" },
    size: {type: "number"},
    infoSize: {type: "number"}
  },
  init() {
    const { positi, size} = this.data;

    const boxEntity = document.createElement('a-entity');
    const parentEl = this.el.parentEl;
    this.el.appendChild(boxEntity);
    const scene = new THREE.Scene();
    const planeGeometry = new THREE.PlaneGeometry(size + 0.5, 1.2);
  
    const material = new THREE.MeshBasicMaterial({ color: 0xebebeb });
    const textMesh = new THREE.Mesh(planeGeometry, material);
    scene.add(textMesh);
    scene.position.z = -0.01

    boxEntity.setObject3D('mesh', scene);   
    this.el.object3D.position.set((size/ 2) - 0.3,this.el.object3D.position.y,this.el.object3D.position.z);
    this.el.object3D.updateMatrix();

  }
});
